import axiosInstance from "./axiosInstance";

export function getInstrctution(page = 1){
    return new Promise((resolve, reject) => {
        axiosInstance.get("/instructions", {
            params: {
                page,
            }
        })
            .then(res => resolve(res.data.data))
            .catch(e => reject(e));
    })
}

export function checkInstructions(id, data) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/check_instructions/${id}`, data)
            .then(res => resolve(res.data))
            .catch(e => reject(e));
    })
}